export default __webpack_public_path__ + "static/media/icon-search-close.5c89c653.svg";